import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_SAP_VERSION_3 = createFcmDetails('starfish_sap_version_3', {
	owner: 'starfish',
	context: 'start a petition page',
	description: 'Toggles start a petition page v3',
	import: false,
});
